import { Router } from 'expo-router';

import { routes } from 'utils/routing';

/**
 * Leaves an unavailable section or product screen for the menu tab.
 * In cold deeplinks, `canDismiss()` can still be true because `(tabs)` is
 * anchored under a deep-linked card, even when `/menu` was never visited.
 * Attempt dismissTo first, then always replace to guarantee recovery.
 */
export function navigateBackToMenu(
  router: Pick<Router, 'canDismiss' | 'dismissTo' | 'replace'>
): void {
  const route = {
    pathname: routes.menu as '/menu',
  };

  if (router.canDismiss()) {
    router.dismissTo(route);
  }

  router.replace(route);
}
